export type ScreenRoute = { kind: 'kitchen'; restaurantId: string; displayId: string }

const LAST_SCREEN_KEY = 'galley.lastScreen'

export function parseRoute(url: URL): ScreenRoute | null {
  try {
    const path = url.pathname.split('/').filter(Boolean).map(decodeURIComponent)
    if (path[0] === 'order' || path[0] === 'buffet') return null
    if (path.length === 2) return { kind: 'kitchen', restaurantId: path[0], displayId: path[1] }
    const config = (url.searchParams.get('c') || url.hash.slice(1)).split('/').map(decodeURIComponent)
    if (config.length === 2 && config.every(Boolean)) return { kind: 'kitchen', restaurantId: config[0], displayId: config[1] }
  } catch {
    // A malformed link must leave the screen picker available.
  }
  return null
}

export function screenPath(route: ScreenRoute): string {
  return `/${encodeURIComponent(route.restaurantId)}/${encodeURIComponent(route.displayId)}`
}

export function startupRoute(url: URL, storage: Pick<Storage, 'getItem'>): ScreenRoute | null {
  const direct = parseRoute(url)
  if (direct || url.pathname !== '/' || url.searchParams.has('choose-screen') || url.searchParams.has('c') || url.hash) return direct
  try {
    const saved = storage.getItem(LAST_SCREEN_KEY)
    if (!saved) return null
    const target = new URL(saved, url.origin)
    if (target.origin !== url.origin || target.search || target.hash) return null
    return parseRoute(target)
  } catch {
    return null
  }
}

export function rememberScreen(storage: Pick<Storage, 'setItem'>, route: ScreenRoute): void {
  try {
    storage.setItem(LAST_SCREEN_KEY, screenPath(route))
  } catch {
    // The screen remains usable when browser storage is unavailable.
  }
}
